<template>
  <div class="container">
    <div class="background">
      <template v-if="userData.userName">
        <div class="user-info" v-if="userData.userName">
          <div class="user-img">
            <img :src="userData.avatar?userData.avatar:''" class="img">
            <!-- <div class="user-level">2</div>
            <div class="user-vip">V</div> -->
          </div>
          <div class="user-name">{{userData.userName}}</div>
          <div class="user-sing">
            <span class="sing-btn":class="ifSinged?'singed':''" @click="sing">{{ifSinged?getDict(61):getDict(62)}}</span>
            <span class="gold-num">
              <i class="icon icon-gold-big"></i>
              <span>{{userData.money | readableNum}}</span>
            </span>
          </div>
          <div class="tab-switch">
            <div class="tab-switch-inline-box">
              <div class="tab" :class="{active:('follow' == activeTab)}" @click="activeTab = 'follow'">
                <i class="icon icon-my-follow"></i>
                <span class="tab-name">{{getDict(65)}}</span>
              </div>
              <div class="tab" :class="{active:('gamble' == activeTab)}" @click="activeTab = 'gamble'">
                <i class="icon icon-gamble"></i>            
                <span class="tab-name">{{getDict(63)}}</span>
              </div>
              <!-- <div class="tab" :class="{active:('subscription' == activeTab)}" @click="activeTab = 'subscription'">
                <i class="icon icon-subscrip"></i>
                <span class="tab-name">{{getDict(64)}}</span>
              </div>              
              <div class="tab" :class="{active:('shop' == activeTab)}" @click="activeTab = 'shop'">
                <i class="icon icon-shop"></i>
                <span class="tab-name">{{getDict(66)}}</span>
              </div> -->
            </div>
          </div>
        </div>
        <div class="right-box">
          <Follow v-if="'follow' == activeTab"></Follow>
          <Subscription v-if="'subscription' == activeTab"></Subscription>
          <Gamble v-if="'gamble' == activeTab"></Gamble>
          <Shop v-if="'shop' == activeTab"></Shop>
        </div>
      </template>
      
      
    </div>
  </div>
</template>

<script>
  import { getDict, axios, getPageLevelMixin, webSocket } from '../../common'
  import { mapState, mapGetters } from 'vuex'
  import alert from '../../components/alert'
  import Follow from './follow'
  import Subscription from './subscription'
  import Gamble from './gamble'
  import Shop from './shop'

  let todayStart = new Date()
  todayStart.setHours(0);
  todayStart.setMinutes(0);
  todayStart.setSeconds(0);
  todayStart.setMilliseconds(0);
  export default {
    name: 'personalCenter',
    mixins:[getPageLevelMixin],
    props:{
    },
    data(){
      return {
        pageLevel:1,
        activeTab:'gamble',
        todayStart,
      }
    },
    computed:{
      ...mapState(['userData']),
      ifSinged(){
        return this.userData.sign_ts >= todayStart.getTime();
      }
    },
    watch:{
    },
    methods: {
      getDict,
      sing(){
        if(this.ifSinged){
          return;
        }
        webSocket.get('/user/sign',{}).then((res)=>{
          this.$store.dispatch('getUserData');
        }).catch((e)=>{
          this.$store.dispatch('getUserData');
        })
      }
    },
    components: {
      alert,Follow,Subscription,Gamble,Shop
    },
    mounted(){
      
    },
    created(){
    }
  }
</script>

<style lang="scss" scoped>
  .container{
    margin: .3rem;
    display: flex;
    flex: 1;
    height: 100%;
    align-items: center;

    .background{
      // height: 100%;
      height: 6rem;
      min-height: 0px;
      $font-size:0.25rem;
      flex: 1;
      display: flex;
      background-color: rgba(35,35,35,0.8);
      font-size:$font-size;
      color: #fff;
      min-width: 0px;

      .user-info{
        display: flex;
        flex-direction: column;
        $user-info-width:3rem;
        $padding: 0.3rem;
        width: $user-info-width;
        margin:0.3rem 0;
        border-right: 1px solid #626262;
        padding: 0 #{$padding};

        .user-img{
          $img-box-padding: $padding;
          $img-box-size: $user-info-width - 2*$padding;
          $img-size: $img-box-size - 2*$img-box-padding;
          width: $img-size;
          height: $img-size;
          margin: 0 #{$img-box-padding};
          position: relative;
          .img{
            width:  $img-size;
            height:  $img-size;
            
            border:2px solid #ffc44f;
            border-radius: 5rem;
          }

          .user-level{
            box-sizing: content-box;
            border:1px solid #ffc44f;
            border-radius: 5rem;
            $level-size:0.4rem;
            width: $level-size;
            height: $level-size;
            position: absolute;
            $position: 0.07rem;
            top:$position;
            left:$position;
            background-color: #555;
            text-align: center;
            line-height: $level-size;
          }

          .user-vip{
            border-radius: 5rem;
            $level-size:0.4rem;
            width: $level-size;
            height: $level-size;
            position: absolute;
            $position: 0.07rem;
            bottom:$position;
            right:$position;
            background-color: #ffc44f;
            text-align: center;
            color: #000;
            line-height: $level-size;
          }
        }
        .user-name{
          margin:0.05rem 0;
          text-align: center;
          font-size: 0.25rem;
        }
        .user-sing{
          display: flex;
          justify-content: space-between;
          padding: 0 0.2rem;
          $font-size:0.18rem;
          font-size: $font-size;
          .sing-btn{
            display: inline-block;
            height: $font-size*1.7;
            line-height: $font-size*1.7;
            text-align: center;
            width: 0.7rem;
            background-color: #ffc952;
            border-radius: 0.05rem;
            color: #000;

            &.singed{
              background-color: #c8c8cb;
            }

            .lang-jp & {
              font-size: 0.13rem;
              // line-height: $font-size * 1.8;
              width: 0.9rem;
            }
            .lang-en & {
              font-size: 0.13rem;
              // width: 0.9rem;
              // line-height: $font-size * 1.8;
            }
          }
          .icon-gold-big{
            $size:0.26rem;
            width: $size;
            height: $size;
            background-color: #464646;
          }
          .gold-num{
            color: #ffc952;
            .icon{
              vertical-align: middle;
            }
          }
          
        }

        .tab-switch{
          margin-top: 0.2rem;
          flex: 1;
          
          display: flex;
          flex-direction: column;
          justify-content: center;
          .tab-switch-inline-box{
            background-color: #24272e;
          }

          .tab{
            // flex: 1;
            height: 0.6rem;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            &:not(:first-child){
              border-top: 1px solid #343539;
            }

            &.active{
              background: url(~@/assets/button.png) center no-repeat;
              background-size: 100% 100%;
              color: #000;

              .icon{
                overflow: hidden;

                &:after{
                  display: block;
                  content: '';
                  width: 100%;
                  height: 100%;
                  background: inherit;
                  transform: translateX(-50px);
                  filter: drop-shadow(50px 0 0 #000);
                }
                
                
              }
            }

            .tab-name{
              width: 60%;
              text-align: center;
              .lang-jp & {
                font-size: 0.2rem;
              }
              .lang-en & {
                font-size: 0.2rem;
              }
            }
          }
        }
      }

      .right-box{
        flex: 1;
        height: 100%;
        min-width: 0px;
      }

      
    }
  }


</style>
